import { VenueSurchargesType } from '@api';
import { DotNotationPaths } from '@common';
import { VenueDetailsOverviewEndKey } from 'src/i18next';

export type VenueSurchargesTableRowType = {
  label: VenueDetailsOverviewEndKey<'VENUE_SURCHARGES.ROWS'>;
  accessor: DotNotationPaths<VenueSurchargesType>;
};

export const venueSurchargesRows: VenueSurchargesTableRowType[] = [
  {
    label: 'FACILITY_FEE',
    accessor: 'facilityFee',
  },
  {
    label: 'PUBLIC_TRANSPORT_FEE',
    accessor: 'publicTransportFee',
  },
  {
    label: 'NOTES',
    accessor: 'notes',
  },
];

